export default __webpack_public_path__ + "static/media/facebook.cbcf8be7.svg";